import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

function NotFoundPage() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Page not found</h1>
        <p style={{ fontSize: '1rem', color: '#ccc' }}>
          The page you're looking for doesn't exist.
        </p>
        <Link to="/" style={{ display: 'inline-block', marginTop: '1rem', color: '#58a6ff', textDecoration: 'underline', fontSize: '1rem' }}>
          Back to Home
        </Link>
      </header>
    </div>
  );
}

export default NotFoundPage;
